import { render, staticRenderFns } from "./ProvideOtherInfo.vue?vue&type=template&id=0d5dec31&scoped=true&"
import script from "./ProvideOtherInfo.vue?vue&type=script&lang=js&"
export * from "./ProvideOtherInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProvideOtherInfo.vue?vue&type=style&index=0&id=0d5dec31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5dec31",
  null
  
)

export default component.exports